import { PurchasePolicyInput } from 'src/redux/reducer/v2/purchasePolicy';
import { SharedReducer } from 'src/redux/reducer/v2/shared';

interface GetBuilding {
  name: string;
  street: string;
  municipality: string;
  state: string;
  postalCode: string;
  complete_address: string;
  fullAddress: {
    label: string;
    municipality: string;
    postalCode: string;
    street: string;
    region: string;
  };
}

type InitialValues = Pick<
  PurchasePolicyInput,
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'phone'
  | 'addressName'
  | 'coverageStart'
  | 'additionalInsuredRoommates'
  | 'buildingId'
  | 'buildingUnit'
> & {
  fixedBuilding?: boolean;
  fixedUnit?: boolean;
};

type CoverageValues = InitialValues & {
  id: string;
  address: PurchasePolicyInput['address'];
  buildingName: PurchasePolicyInput['buildingName'];
  companyVendor: SharedReducer['companyVendor'];
  buildingAddress: {
    value: GetBuilding & {
      addressNumber: string;
    };
  };
};

export const getCreateCommunityInput = (
  data: CoverageValues,
  buildingDetails: CoverageValues['buildingAddress']['value'],
) => {
  return {
    communityName: data.buildingName || data.addressName || '',
    coverageStart: data.coverageStart,
    buildingId: data.buildingId,
    building: {
      yearBuilt: parseInt('2000'),
      zipCode: buildingDetails.postalCode,
      addressState: buildingDetails.state,
      addressCity: buildingDetails.municipality,
      addressStreet: data.companyVendor
        ? buildingDetails.street
        : `${buildingDetails.addressNumber || ''} ${buildingDetails.street}`,
    },
  };
};
